module.exports = "/images/pregnancy-background.png?9421e8df10f90a56168593e6bfb58062";